<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      border
      auto-resize
      highlight-hover-row
      :height="350"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :columns="tableColumns"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex mt-2">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_label_put_shelves_sku') || '上架SKU' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <el-button size="mini" type="primary" plain @click="chooseHxSku">
              {{ $l('btn_put_shelves_sku') || '选择上架SKU' }}
            </el-button>
          </div>
        </div>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>

    <ChooseHxSku
      :visible.sync="chooseHxSkuVisible"
      :hxSkuStatus="['Y']"
      :extraData="{ listNonPlatformCode: [platformCode] }"
      multiple
      reserve
      confirm-on-close
      @confirm="chooseHxSkuConfirm"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns.js'
import ChooseHxSku from '../choose-hx-sku'
import { getLang } from '@/libs/util.lang'
export default {
  components: { ChooseHxSku },
  props: {
    platformCode: { type: String, default: '' },
  },
  data() {
    return {
      chooseHxSkuVisible: false,
      tableColumns: tableColumns(this),
      editRules: {
        channelItemNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ row }) => {
              const { channelItemNo, _X_ID } = row
              const tableData = this.getTableData().filter(
                (item) => item._X_ID !== _X_ID
              )
              if (!tableData?.length) return
              const data = tableData.filter(
                (item) => item.channelItemNo === channelItemNo
              )
              if (data?.length) {
                return new Error(
                  this.$l('tips_table_rules_repeat_channelItemNo')
                )
              }
            },
          },
        ],
        channelEanNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ row }) => {
              const { channelEanNo, _X_ID } = row
              const tableData = this.getTableData().filter(
                (item) => item._X_ID !== _X_ID
              )
              if (!tableData?.length) return
              const data = tableData.filter(
                (item) => item.channelEanNo === channelEanNo
              )
              if (data?.length) {
                return new Error(
                  this.$l('tips_table_rules_repeat_channelEanNo')
                )
              }
            },
          },
        ],
        salesPrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  methods: {
    chooseHxSku() {
      if (!this.platformCode) {
        this.$message({ message: '请先选择需要上架的渠道', type: 'warning' })
        return
      }
      this.chooseHxSkuVisible = true
    },
    async chooseHxSkuConfirm(data) {
      if (!data?.length) return

      // 判断是否已经选中的数据
      const tableData = this.getTableData()
      if (tableData?.length) {
        const findIndex = data.findIndex((item) => {
          return (
            tableData.findIndex((row) => item.hxSkuCode == row.hxSkuCode) >= 0
          )
        })
        if (findIndex >= 0) {
          this.$message('存在重复上架的SKU，已自动过滤！')
        }

        data = data.filter((item) => {
          return (
            tableData.findIndex((row) => item.hxSkuCode == row.hxSkuCode) < 0
          )
        })
      }
      if (!data?.length) return

      const newRows = data.map((item) => {
        const {
          hxSkuCode,
          hxSkuNo,
          goodsName,
          goodsNameEn,
          brandCode,
          brandName,
          inCtnQty,
          eanCode,
        } = item

        const language = getLang()

        return {
          hxSkuCode,
          hxSkuNo,
          channelItemNo: '',
          channelEanNo: eanCode,
          brandCode,
          brandCodeText: brandName,
          salesTitle: goodsName || goodsNameEn,
          salesPrice: 0,
          salesCurrencyUnit: 'CNY',
          salesCurrencyUnitText: language == 'en' ? 'CNY' : '人民币',
          sellableEachQty: inCtnQty,
          sellableEachUnit: 'case',
          sellableEachUnitText: language == 'en' ? 'case' : '整箱',
        }
      })

      const $table = this.$refs.skuTable
      const { rows: insertRows } = await $table.insertAt(newRows, -1)
      $table.setActiveCell(insertRows[0], 'salesPrice')
    },
    del(row) {
      this.$refs.skuTable.remove(row)
    },
    async validate() {
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
    getTableData() {
      const { fullData } = this.$refs.skuTable.getTableData()
      if (!fullData?.length) return []
      return fullData.map((item) => {
        const { brandCodeText: brandName, ...data } = item
        return { ...data, brandName }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
